// axios
import axios from 'axios'

const baseURL = 'https://restapi.turkishrestaurant.com'

export default axios.create({
  baseURL,
  withCredentials:false
  // You can add your headers here
})
